import React, { useContext } from 'react';
import { LangContext } from '../../contexts/langContext';
import { SocialContext } from '../../contexts/socialContext';
import { StateContext } from '../../contexts/stateContext';
import GateFocused from '../UiKit/GateFocused';
import { FriendsWith } from '../UiKit/FriendsWith';
import { GateAllActivations } from '../UiKit/GateAllActivations';
import { GateInfo } from '../UiKit/GateInfo';
import { Videos } from '../UiKit/Videos';
import { findGateInUser } from '../utilsDesign';
import { Background } from '../UiKit/Background';
import { ChannelPentaActivations, ChannelTypeInfo } from '../UiKit/Channel';

export function StudyGate(props) {

  const {
    design,
    gateId = parseInt(gateId),
    types = [],
    circuit = '',
    stream = '',
    penta,
  } = { ...props };

  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) };
  const $center = context.$center;
  const $ui = context.$ui;
  const $gate = context.$gate;


  return (
    <>

      <div className="x_info_section">
        <div className="x_info_w x_info_w--100" style={{ position: 'relative' }}>
          <GateFocused
            design={design}
            gateId={gateId}
            style={{
              width: '100%',
              height: '8em',
              marginTop: '-1em',
              zIndex: 1,
            }} />
          <Background
            // style={{ zIndex: -1 }}
            aura={true}
            design={design}
          />
        </div>
      </div>


      <div className="_fv _fgap1 _f100">
        <div className="x_info_section">
          <div className="x_info_w _fgap1">

            {/* <Gate
              key={`gate_${gates[0]}`}
              label={false}
              design={design}
              gateNumber={gates[0]}
            // expert={expert}
            /> */}

            <GateInfo
              design={design}
              number={true}
              title={true}
              hexagram={true}
              description={true}
              gateId={gateId}
              {...props}
              // types={types}
              // circuit={circuit}
              // stream={stream}
            />



            <ChannelTypeInfo
              {...props}
            />

            <div className="_fv _fgap04">
              <div className="x_channel_typeinfo">{$ui('edu_show_activations')}:</div>

              {penta ? (
                <ChannelPentaActivations
                  penta={penta}
                  gates={[gateId]}
                  number={false}
                  hexagram={false}
                  planets={true}
                  stack={true}
                />
              ) : (
                <GateAllActivations
                  planets={true}
                  number={false}
                  hexagram={false}
                  design={design}
                  gateId={parseInt(gateId)}
                />
              )}
              {!Boolean(findGateInUser(design.gates, gateId).length) && <div className="x_edu_badge x_edu_badge--open">
                {$ui('edu_gate_no_activations')}
              </div>}
            </div>


            <Videos
              title={`${$gate(gateId, 'id')}. ${$gate(gateId, 'title')}`}
              size='sm'
              relType='gates'
              relValue={gateId.toString()}
            />

          </div>
        </div>
        {Boolean(context.me) && <div className="x_info_section _fv _f100 _fr ">
          <div className="x_info_w">
            <FriendsWith
              size=''
              titleAfter={<b>{$ui('edu_gate_activated_in')}</b>}
              filterCase={a => a.filter(one => design && findGateInUser(one.avatar.design.gates, gateId).length)}
            />
          </div>
        </div>}

      </div>


    </>


  )
}
